import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';
// import { formatNumber } from 'helper';

function LineChart({ data, isLoading, seriesName, chartOptions }) {
  const defaultOptions = {
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: data?.map((item, i) => item?.label ?? `Data ${i + 1}`),
    },
    yaxis: {
      tickAmount: 5,
      min: 0,
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: true,
    },
    colors: ['#977ed1'],
  };

  const series = [
    {
      name: seriesName,
      data: data?.map((item) => item?.count ?? null),
    },
  ];
  if (isLoading) {
    return (
      <div className="h-full w-full pl-10 py-8 pr-6">
        <div
          className="animate-pulse bg-gray-200 h-full w-full rounded"
          style={{
            clipPath:
              'polygon(0 80%, 13% 71%, 25% 55%, 39% 44%, 54% 51%, 66% 46%, 78% 34%, 90% 22%, 100% 33%, 100% 43%, 100% 100%, 0% 100%)',
          }}
        />
      </div>
    );
  }
  return (
    <ReactApexCharts
      height="100%"
      options={{ ...defaultOptions, ...chartOptions }}
      series={series}
      type="area"
    />
  );
}
LineChart.defaultProps = {
  data: {
    labels: [],
    series: [],
  },
  isLoading: false,
  seriesName: 'Count',
  chartOptions: {},
};

LineChart.propTypes = {
  data: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
  seriesName: PropTypes.string,
  chartOptions: PropTypes.instanceOf(Object),
};

export default LineChart;
